import { preloadPostOfficePlacementWithSessionContext } from '@atlassian/confluence-post-office-provider/entry-points/preload-placement';

export const preloadPostOfficeConfluenceHomeBanner = async () => {
	return preloadPostOfficePlacementWithSessionContext('confluence-home-banner');
};
